import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAddressByZipCode} from '../../services/getAddressByZipCode';

export function useGetAddressByZipCodeQuery(cep: string) {
	return useQuery({
		queryKey: [QUERY_KEYS.ADDRESS_BY_ZIP_CODE, cep],
		queryFn: async ({signal}) => getAddressByZipCode({cep, signal}),
		enabled: false,
		retry: 2,
	});
}
